import React, { HTMLProps } from 'react'
import styled from 'styled-components'
import colors from '../../constants/colors'
import Flex from '../Flex'
export interface PageLinkRootProps {
  children?: React.ReactNode
  className?: string
  active?: boolean
  disabled?: boolean
}

export type Props = HTMLProps<HTMLAnchorElement> & PageLinkRootProps

export const PageLinkContainer = styled(Flex)`
  background: transparent;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;

  &:hover {
    color: ${colors.blue50};
  }

  &.RnPagelink-active {
    color: ${colors.white};
    border-color: ${colors.blue50};
    background-color: ${colors.blue50};
  }

  &.RnPagelink-disabled {
    cursor: not-allowed;
  }
`
